// plugins/summernote.js
import $ from 'jquery';
import 'summernote/dist/summernote-lite.css';
import 'summernote/dist/summernote-lite.js';

export default defineNuxtPlugin((nuxtApp) => {
  // Inject jQuery into the Nuxt app
  nuxtApp.provide('jquery', $);
});
